// extracted by mini-css-extract-plugin
module.exports = {"draft-banner":"draft-banner_draft-banner__a1Tu8"};